export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProviderDetails.vue?vue&type=template&id=4fadbb80&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/ProviderDetails.vue?vue&type=template&id=4fadbb80&scoped=true
// module id = 2465
// module chunks = 31